import { render } from "./AppToggleSwitch.vue?vue&type=template&id=6cbcd85a&scoped=true&ts=true"
import script from "./AppToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./AppToggleSwitch.vue?vue&type=script&lang=ts"

import "./AppToggleSwitch.vue?vue&type=style&index=0&id=6cbcd85a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbcd85a"]])

export default __exports__